










































import { Component, Vue } from "vue-property-decorator"
import { mapState } from "vuex"
import CandidateDashboardCandidateForm from "./Dashboard/CandidateDashboardCandidateForm.vue"

@Component({
  components: {
    CandidateDashboardCandidateForm,
  },
  computed: {
    ...mapState("Auth", {
      candidate: "candidate",
    }),
    ...mapState("Auth", {
      user: "user",
    }),
    ...mapState("CandidateProfile", {
      candidateProfile: "candidateProfile",
    }),
  },
})
export default class CandidateWelcome extends Vue {
  // candidate State
  candidate!: Model
  user!: Model

  // candidateProfile State
  candidateProfile!: CandidateProfile

  welcomeText() {
    return (
      "Hello " +
      this.user.name +
      " " +
      this.user.surname +
      ", we know you are " +
      this.candidate.age +
      " years old, and live in postcode " +
      this.candidate.postcode
    )
  }

  beforeMount() {
    this.$store.dispatch("CandidateProfile/fetchByCandidate")
  }

  goCandidateProfile() {
    this.$router.push({
      name: "candidate-profile-update",
    })
  }

  goDashboard() {
    this.$router.push({
      name: "candidate-dashboard",
    })
  }
}
